import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Genre } from "../model/genre";


@Injectable({
    providedIn: 'root'
  })
export class GenreService {

    private apiUrl = environment.apiSecurityUrlGenre;

    constructor(
      private http: HttpClient) {
      }

    getGenres(): Observable<Genre[]> {
      return this.http.get<Genre[]>(this.apiUrl);
    }
}
